/**
 * React Query hook for fetching item customization template.
 * Calls zaviago_backend.customization_api.get_item_customization
 */

import { useQuery } from '@tanstack/react-query';
import { frappeMethod } from '@/lib/erp/utils';
import type { ItemCustomization } from '../lib/types';

export function useItemCustomization(itemCode: string | null, company?: string) {
  return useQuery({
    queryKey: ['item-customization', itemCode, company],
    queryFn: () =>
      frappeMethod<ItemCustomization>(
        'zaviago_backend.customization_api.get_item_customization',
        { item_code: itemCode!, company: company || undefined },
      ),
    enabled: !!itemCode,
    staleTime: 5 * 60 * 1000, // 5 min — templates rarely change
  });
}
